import axios from 'axios'
import vuetify from '@/plugins/vuetify'
import router from '@/router'

export default {
  namespaced: true,

  state: {
    loaded: false,
    dark: false,
    compactMenu: true,
  },

  mutations: {
    loaded_set (state, val) {
      state.loaded = val
    },

    dark_set (state, val) {
      state.dark = val
      localStorage.setItem('dark', val)
      // собственно меняем тему
      vuetify.framework.theme.dark = val
    },

    compactMenu_set (state, val) {
      state.compactMenu = val
      localStorage.setItem('compactMenu', val)
    }
  },

  getters: {
    dark: state => {
      if (state.loaded) return state.dark
      const storeValue = localStorage.getItem('dark')
      if (storeValue) return storeValue === 'true'
      return false
    },

    compactMenu: state => {
      return state.compactMenu
    }
  },

  actions: {
    async init ({ commit }) {
      try {
        const response = await axios.get('/settings/getSettings')
        commit('loaded_set', true)
        commit('dark_set', response.data.dark)
        commit('compactMenu_set', response.data.compactMenu)
      } catch {
        router.push('/error?message=Ошибка при загрузке настроек пользователя')
      }
    },

    setDark ({ commit }, value) {
      commit('dark_set', value)
      axios.patch('/settings/setDark/' + value)
    },

    setCompactMenu ({ commit }, value) {
      commit('compactMenu_set', value)
      axios.patch('/settings/setCompactMenu/' + value)
    },

    reset ({ commit }) {
      commit('loaded_set', false)
    }
  }
}
